import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import MaterialTransparentDetail from '../../components/material_opaque/MaterialTransparentDetail';
import { editMaterialTransparent } from '../../redux/material_transparent/material_actions';
import {defaultRejectHandler, fromMilli} from '../../utils/utility';

export class MaterialTransparentEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.materialDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newMaterial = this.materialDetail.getWrappedInstance().getMaterialData();
    this.props.editMaterial({...newMaterial, id: this.props.material.id});
  }

  render() {
    const { isEditing, errorMessage, material, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit transparent material')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MaterialTransparentDetail
            material={material}
            ref={ref => (this.materialDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="material-transparent-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.material.transparent.errorMessage,
  isEditing: state.material.transparent.isEditing,
});

const mapDispatchToProps = dispatch => ({
  editMaterial: material =>
    defaultRejectHandler(
      dispatch(
        editMaterialTransparent(
          material.id,
          material.name,
          fromMilli(material.thickness),
          material.SHGC,
          material.U,
          material.transmittance,
          material.description,
          material.image,
          material.cfp_value,
          material.cfp_unit,
        )
      )
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MaterialTransparentEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/material_transparent/MaterialTransparentEditModal.js